import { gql } from '@apollo/client';

export const GET_SUSPENSION_CODES = gql`
  query ListSuspensionCodes {
    listSuspensionCodes {
      comment
      code
      shortDescription
      longDescription
      points
    }
  }
`;
